import { useMemo } from "react";
import useUserLayoutPreferences from "./useUserLayoutPreferences";
const useTableLayout = ({
  entityTableId,
  layoutVariant,
  defaultSort,
  defaultSlicing,
  defaultPageSize
}) => {
  const { data: userLayoutPreferences = {}, isInitialLoading } = useUserLayoutPreferences(entityTableId, layoutVariant);
  return useMemo(() => {
    var _a, _b, _c;
    const hasSlicingPreference = Object.prototype.hasOwnProperty.call(userLayoutPreferences, "slicing");
    return {
      layoutConfig: {
        attributes: userLayoutPreferences == null ? void 0 : userLayoutPreferences.attributes,
        order: userLayoutPreferences.order,
        pageSize: (_a = userLayoutPreferences.perPage) != null ? _a : defaultPageSize,
        slicing: hasSlicingPreference ? (_b = userLayoutPreferences.slicing) != null ? _b : void 0 : defaultSlicing,
        sort: (_c = userLayoutPreferences.sort) != null ? _c : defaultSort
      },
      isInitialLoading
    };
  }, [defaultPageSize, defaultSlicing, defaultSort, isInitialLoading, userLayoutPreferences]);
};
export default useTableLayout;
